import { Component } from '@angular/core';
import { DocumentSearchResult } from '../document/models/documentSearchResult';
import { DocumentLibraryConstants } from '../document/document-library-constants';
import { MyAssignAdminService } from './services/my-assign-admin.service';
import { LabelConstants } from '../shared/constants/label-constants';

@Component({
  selector: 'app-my-assign-admin',
  templateUrl: './my-assign-admin.component.html',
  styleUrls: ['./my-assign-admin.component.scss']
})
export class MyAssignAdminComponent {
  documentSearchResult: DocumentSearchResult[] = [];
  dispalyCheckBoxes: boolean = false;
  displayInActiveButton: boolean = true;
  enableDocumentFavoriteCheck: boolean = false;
  isIncludeInactive: boolean = false;
  displayInActiveLabel: boolean = true;
  displayInformationIconCheckbox: boolean = true;
  topBarTitle:string = DocumentLibraryConstants.MyAssignAdminTitle;
  informationIconToolTipMessage: string = DocumentLibraryConstants.ToolTipMessage_InActiveIcon;
  showInActiveLabel:string = DocumentLibraryConstants.ShowInActive_Label;
  showLoader: boolean = true;
  isScreenAccessible : boolean = true;
  errorMessage !: string;
  
  constructor(private myAssignAdminService: MyAssignAdminService){ }

  ngOnInit(): void{
    this.getPanelListData(this.isIncludeInactive);
  }

  getPanelListData(isIncludeInactive: boolean){
      this.myAssignAdminService.getAssignedAdminDocuments(isIncludeInactive).subscribe({
          error: (err) => {
              if (err.status === LabelConstants.Forbidden_StatusCode) {
                  this.errorMessage = err.error.detail;
              }
              this.isScreenAccessible = false
          },
          next: (serviceData) => {
              this.documentSearchResult = serviceData;
              this.showLoader = false;
          }
    });
  }

  includeInactive(isIncludeInactive:boolean){
    this.getPanelListData(isIncludeInactive);
  }
}
